// extracted by mini-css-extract-plugin
module.exports = {"register-operating-time":"style_register-operating-time__2y9Ml"};